import { TeamsSenderLayout } from "../TeamsSenderLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { TeamsSenderRouterProps } from "../TeamsSenderRouterProps";
import { TeamsSenderEntities } from "../TeamsSenderEntities";
import { NamirasoftMap } from "namirasoft-site-map";

export interface SentListPageProps extends NSARouterMakerResult, TeamsSenderRouterProps
{ }

function SentListPage(props: SentListPageProps)
{
	let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

	return (
		<TeamsSenderLayout {...props}
			action={{
				title: "Report",
				description: "View detailed reports of the messages sent, including chat id, message_thread_id, message, date, and time.",
				menus: {}
			}}
			pages={{
				entity: TeamsSenderEntities.sent(props),
				list: {
					ui: {
						search_box: {
							exclude: {
								load_value: (table, column) =>
								{
									if (namirasoft.teams_sender.tables.sent.name === table)
									{
										let columns = [
											namirasoft.teams_sender.tables.sent.columns.message.name,
											namirasoft.teams_sender.tables.sent.columns.result.name,
										]
										return columns.includes(column);
									}
									return false;
								}
							}
						}
					}
				}
			}}
		>
			<></>
		</TeamsSenderLayout>
	);
}

export default SentListPage;